"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createBrowserHistory_1 = __importDefault(require("history/createBrowserHistory"));
var history = {};
if (typeof window === "object") {
    history = (0, createBrowserHistory_1.default)();
}
exports.default = history;
